export default "<p>atendimento-dashboard works!</p>\n";